const initialState = {
  data: { 1: { resources: [], connections: [] } },
};

export default initialState;
